/**
 * Plugin para A/B Testing
 * Color acá todas las inyecciones de código necesarias
 * El store tendrá seteado la experiencia inyectada desde target
 * `state.adobeTargetExperience`
 * El proceso es antes de entrar a una ruta, verificar que sea el paso
 * donde queremos hacer la modificación y verificar que la experiencia deseada
 * esté activa (indicado por Target) y aplicar el cambio
 */
import Vue from "vue";
import store from "@/store";
import { mapState } from "vuex";

const ABTesting = {
  install() {
    // Escuchamos el store por cambios de rutas y vemos si tenemos que
    // aplicar un test. Se hace en cada ruta porque algunos tests se
    // aplican en pasos específicos
    store.watch(
      store.getters.getRoute,
      route => {
        if (route && route.name) {
          this.applyAbTestExperience(
            store.getters.getAdobeTargetExperience(),
            route.name
          );
        }
      },
      { immediate: true }
    );
    // Escuchamos el store por cambios en la experiencia de Adobe Target
    // para aplicar el cambio apenas Target dispare el dispatch
    store.watch(
      store.getters.getAdobeTargetExperience,
      experience => {
        let route = store.getters.getRoute();
        if (experience && route && route.name) {
          this.applyAbTestExperience(experience, route.name);
        }
      },
      { immediate: true }
    );
    //mixin para todos los componentes
    Vue.mixin({
      computed: {
        ...mapState({
          adobeTargetExperience: state => state.adobeTargetExperience
        })
      }
    });
  },
  applyAbTestExperience(experience, route) {
    /**
     * Código para cada test en particular
     * El código de la actividad DEBE venir como `IDACTIVIDAD_EXPERIENCIA`
     * para ser identificado por el tagging
     */
    Vue.$log.info("Adobe Target", "Aplicando experiencia", experience, route);
  }
};

Vue.prototype.$ABTesting = ABTesting;

export default ABTesting;
